import { createReducer } from '@reduxjs/toolkit'
import * as types from './types'

const initialState = {
  items: [],
  isFetching: false,
  isError: false,
  isFinished: false,
  errorMessage: '',
  currentItem: {},
  pagination: {
    total: 1,
    pageCount: 1
  }
}

const doormenReducer = createReducer(initialState, {
  [types.CREATE_DOORMAN]: (state, action) => ({
    ...initialState,
    isFetching: true
  }),
  [types.CREATE_DOORMAN_FAILURE]: (state, action) => ({
    ...state,
    currentItem: {},
    isFetching: false,
    isError: true,
    isFinished: true,
    errorMessage: action.payload
  }),
  [types.CREATE_DOORMAN_SUCCESSFUL]: (state, action) => ({
    ...state,
    currentItem: { ...action.payload },
    isFetching: false,
    isFinished: true,
    errorMessage: ''
  }),
  [types.GET_DOORMEN]: (state, action) => ({
    ...initialState,
    isFetching: true
  }),
  [types.GET_DOORMEN_SUCCESSFUL]: (state, action) => ({
    ...state,
    items: action.payload.data,
    pagination: {
      total: action.payload.meta.total_count,
      pageCount: action.payload.meta.page_count
    },
    isFetching: false,
    isError: false,
    errorMessage: ''
  }),
  [types.GET_DOORMEN_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isError: true,
    errorMessage: action.payload
  }),
  [types.CLEAR_DOORMAN_REDUCER]: (state, action) => ({
    ...initialState
  })
})

export default doormenReducer
